import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export abstract class LoggerService {
  abstract warn(message: string, context?: {[x: string]: any}): void;

  abstract error(message: string, context?: {[x: string]: any}): void;
}
